import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type { Owner } from '@ember/test-helpers/build-owner';
import Component from '@glimmer/component';

import type { StepContext } from '../ui/classic/multi-step-modal/component';

interface ParkingLandingArgs {
  resourceTypeId: string;
  resourceTypeLabel: string;
  stepContext: StepContext;
  onContinue: () => void;
  onClose: () => void;
  setAddParkingOption: (option: string | null) => void;
}

export default class ParkingLandingComponent extends Component<ParkingLandingArgs> {
  @service declare router: RouterService;

  constructor(owner: Owner, args: ParkingLandingArgs) {
    super(owner, args);

    // Reset the addSpotsOption when entering this step
    this.args.setAddParkingOption(null);
  }

  get options(): { key: string; label: string; description: string; image?: string }[] {
    return [
      {
        key: 'map',
        label: 'Create on map',
        description: 'Place and name spots directly on the map',
        image: 'resource-map.svg',
      },
      {
        key: 'list',
        label: 'Create a list',
        description: 'Create an inventory of parking spots',
        image: 'resource-inventory.svg',
      },
      {
        key: 'import',
        label: 'Import data',
        description: 'Upload a .csv file with existing data',
        image: 'resource-upload-csv.svg',
      },
    ];
  }

  @action
  handleSelectOption(option: string): void {
    this.handleSelectedOptionAction(option);
  }

  handleSelectedOptionAction(option: string): void {
    switch (option) {
      case 'map':
        this.handleNavigateToMaps();
        break;
      case 'import':
        this.handleNavigateToImportData();
        break;
      default:
        this.args.onContinue();
    }
  }

  handleNavigateToMaps = (): void => {
    this.args.onClose();
    this.router.transitionTo('spaces.maps.edit');
  };

  handleNavigateToImportData = (): void => {
    this.args.onClose();
    this.router.transitionTo('resources.resource-type.import', this.args.resourceTypeId);
  };
}
